import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "mt-5 px-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "unpaid-footer-container",
  class: "sticky bottom-0 z-10"
}, null, -1)

import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import Card from 'primevue/card'
import { onMounted, ref, watch, computed } from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import UnpaidList from './pages/UnpaidList.vue'
import CheckerVerification from './pages/CheckerVerification.vue'
import FinanceVerification from './pages/FinanceVerification.vue'
import DoneList from './pages/DoneList.vue'
import PrintReportDialog from './components/PrintReportDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const endpoint = 'transaction/v2/FuelingPaymentBatches'
const headerTitle = 'Batch Pembayaran BBM'
const store = useStore()
const tabPositionStorageKey = 'fuel-payment-batch-tab-position'
const showPrintDialog = ref(false)
const savedTabPosition = Number(sessionStorage.getItem(tabPositionStorageKey))
if (Number.isInteger(savedTabPosition) && savedTabPosition >= 0 && savedTabPosition <= 3) {
  store.dispatch('setTabPosition', savedTabPosition)
}
const tabHeader = ref([
  { title: 'Buat Batch', value: 0, status: null, hasCount: false, count: 0 },
  { title: 'Verifikasi Checker', value: 1, status: 'CheckerVerification', hasCount: true, count: 0 },
  { title: 'Refund', value: 2, status: 'FinanceVerification', hasCount: true, count: 0 },
  { title: 'Selesai', value: 3, status: 'Completed', hasCount: false, count: 0 },
])
// const currTabIndex = ref(0)
const currTabIndex = computed({
  get: () => store.getters.getTabPosition,
  set: (value) => {
    sessionStorage.setItem(tabPositionStorageKey, String(value))
    store.dispatch('setTabPosition', value)
  }
})

const tabsChange = (val: any, index: any) => {
  console.log('change', [val, index])
  currTabIndex.value = index
}

const getTabCount = () => {
  apiUseCase.get(`${endpoint}/ByStatusChangeStep/Summary`).then((response) => {
    const { error, result } = response
    if (!error && Array.isArray(result)) {
      result.forEach((item: any) => {
        const targetTab = tabHeader.value.find((tab) => tab.status === item.Status)
        if (targetTab) {
          if (item.StatusDisplayName) {
            // targetTab.title = item.StatusDisplayName
          }
          const countVal = item.Count || 0
          targetTab.count = countVal
          // targetTab.hasCount = countVal > 0
        }
      })
    }
  })
}

const handleSuccessBatch = () => {
  currTabIndex.value = 1
  getTabCount()
}

onMounted(() => {
  getTabCount()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), {
      class: "card-no-shadow wrap-hjp-data-table !rounded-b-none",
      style: {"border-bottom-left-radius":"0 !important","border-bottom-right-radius":"0 !important"}
    }, {
      title: _withCtx(() => [
        _createVNode(HeaderCustom, {
          titleHeader: headerTitle,
          showSearch: false,
          showAddBtn: true,
          titleButton: "Print Transaksi",
          iconButton: "<i class='pi pi-print text-white text-base mr-1'></i>",
          onRedirectAdd: _cache[0] || (_cache[0] = ($event: any) => (showPrintDialog.value = true))
        })
      ]),
      content: _withCtx(() => [
        _createVNode(HjpTabView, {
          currActive: _unref(currTabIndex),
          onTabsChange: tabsChange,
          tabHeader: tabHeader.value
        }, null, 8, ["currActive", "tabHeader"]),
        _createElementVNode("div", _hoisted_2, [
          (_unref(currTabIndex) === 0)
            ? (_openBlock(), _createBlock(UnpaidList, {
                key: 0,
                onOnSuccessBatch: handleSuccessBatch
              }))
            : _createCommentVNode("", true),
          (_unref(currTabIndex) === 1)
            ? (_openBlock(), _createBlock(CheckerVerification, { key: 1 }))
            : _createCommentVNode("", true),
          (_unref(currTabIndex) === 2)
            ? (_openBlock(), _createBlock(FinanceVerification, { key: 2 }))
            : _createCommentVNode("", true),
          (_unref(currTabIndex) === 3)
            ? (_openBlock(), _createBlock(DoneList, { key: 3 }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(PrintReportDialog, {
      visible: showPrintDialog.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showPrintDialog).value = $event))
    }, null, 8, ["visible"])
  ]))
}
}

})